export const checkoutLinkUsesTrial = ({
  planType,
  freePlan,
  trial,
  onAnnualPaidMonthly,
}) => {
  if (typeof planType !== "string") return false;
  if (planType.includes("shopify")) return false;
  if (planType.includes("annual")) return false;
  if (onAnnualPaidMonthly === true) return false;
  if (trial && !freePlan) return true;
  if (planType.includes("personal") || planType.includes("prime")) return false;
  return Boolean(freePlan && !trial);
};

var pricing_table = function () {
  // Match plan tiers across stripe + shopify ids (e.g. 2026_prime / 2026_shopify_prime).
  // Never use includes("2026_prime") — "2026_shopify_prime" does not contain that substring.
  // Never use includes("pro") alone — "prime" contains "pro".
  const isPersonalPlanType = (planType) =>
    typeof planType === "string" && planType.includes("personal");
  const isPrimePlanType = (planType) =>
    typeof planType === "string" && planType.includes("prime");
  const isProPlanType = (planType) =>
    typeof planType === "string" &&
    planType.includes("pro") &&
    !planType.includes("prime");
  const isPlus2MillionPlanType = (planType) =>
    typeof planType === "string" && planType.includes("plus_2million");
  const isPlusPlanType = (planType) =>
    typeof planType === "string" &&
    planType.includes("plus") &&
    !planType.includes("plus_2million");

  $('.feature-popover[data-toggle="popover"]').popover({
    html: true,
    trigger: "hover",
  });

  // Onboarding welcome (and other pages) call account_plan_modal → pricing_table
  // without rendering subscriptions/_pricing, which defines these globals.
  // Bare `!current_plan` throws ReferenceError when the binding was never set.
  if (typeof plans === "undefined" || typeof subscription === "undefined") {
    return;
  }

  if (typeof current_plan === "undefined" || !current_plan) {
    current_plan = plans[subscription.stripe_plan] || {
      stripe_plan: subscription.stripe_plan,
      plan_type: "free",
      price: 0,
    };
  }

  window.contactUsButton = function () {
    function loadMeetingPopup() {
      convertflow.load({
        cta_id: 123204,
        callback: function (cta, variant, embed) {
          convertflow.trigger({
            cta_id: 123204,
          });
        },
      });
    }

    if (!window.convertflow) {
      $.getScript(
        "https://js.convertflow.co/production/websites/3.js",
        function () {
          window.addEventListener("cfReady", function (event) {
            loadMeetingPopup();
          });
        }
      );
    } else {
      convertflow.trigger({
        cta_id: 123204,
      });
    }
  };

  var viewsBuilderPlanTypes = [
    "2026_personal",
    "2026_personal_annual",
    "2026_shopify_personal",
    "2026_prime",
    "2026_prime_annual",
    "2026_shopify_prime",
    "2026_pro",
    "2026_pro_annual",
    "2026_shopify_pro",
    "2026_plus",
    "2026_plus_annual",
    "2026_shopify_plus",
    "2026_plus_2million",
    "2026_plus_2million_annual",
    "2026_shopify_plus_2million",
    "2026_scale_1million",
    "2026_scale_1million_annual",
    "2026_enterprise",
    "2026_enterprise_annual",
    "2026_enterprise_8million",
    "2026_enterprise_8million_annual",
    "2026_enterprise_15million",
    "2026_enterprise_15million_annual",
    "2026_enterprise_30million",
    "2026_enterprise_30million_annual",
    "2026_enterprise_50million",
    "2026_enterprise_50million_annual",
    "2025_pro",
    "2025_pro_annual",
    "2025_shopify_pro",
    "2025_shopify_pro_annual",
    "2025_plus",
    "2025_plus_annual",
    "2025_shopify_plus",
    "2025_shopify_plus_annual",
    "2025_scale",
    "2025_scale_annual",
    "2025_shopify_scale",
    "2025_shopify_scale_annual",
  ];

  // Include any matching plan boxes on the page (e.g. 2026 Shopify) even if omitted above
  $(".pricing-box-outer[data-plan]").each(function () {
    var planType = $(this).attr("data-plan");
    if (
      planType &&
      viewsBuilderPlanTypes.indexOf(planType) === -1 &&
      (planType.indexOf("2026_") === 0 || planType.indexOf("2025_") === 0) &&
      plans[planType] &&
      plans[planType].views_plan
    ) {
      viewsBuilderPlanTypes.push(planType);
    }
  });

  $(viewsBuilderPlanTypes).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const usageOuterDiv = $(plan_div).find(".plan-usage-select-outer");
      if (usageOuterDiv.length === 0) {
        return;
      }
      const usageOuterDivContent =
        '<select class="field-control text-field plan-views-select"></select>';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const buttonWrapper = $(plan_div).find(".plan-button");
      const plan = plans[plan_type];
      if (!plan) {
        return;
      }
      const viewsPlan = viewsPlans[plan.views_plan];
      if (!viewsPlan) {
        return;
      }
      const isAnnualPlan = plan_type.indexOf("annual") > -1;

      // build views volume dropdown
      $(usageOuterDiv).html(usageOuterDivContent);

      const usageSelect = $(usageOuterDiv).find("select");

      // Determine views cap based on plan type
      const getViewsCap = (planType) => {
        // 2026 plans have specific caps
        if (planType.includes("2026_")) {
          if (isPersonalPlanType(planType)) return 100000;
          // Cap below Pro included (100k views / 10k actions) — beyond this Prime costs more than Pro
          if (isPrimePlanType(planType)) return 90000;
          if (isProPlanType(planType)) return 300000;
          if (isPlus2MillionPlanType(planType)) return 4000000;
          if (isPlusPlanType(planType)) return 2000000;
          if (planType.includes("2026_enterprise")) {
            const nextPlanMap = {
              "2026_enterprise": "2026_enterprise_8million",
              "2026_enterprise_annual": "2026_enterprise_8million_annual",
              "2026_enterprise_8million": "2026_enterprise_15million",
              "2026_enterprise_8million_annual":
                "2026_enterprise_15million_annual",
              "2026_enterprise_15million": "2026_enterprise_30million",
              "2026_enterprise_15million_annual":
                "2026_enterprise_30million_annual",
              "2026_enterprise_30million": "2026_enterprise_50million",
              "2026_enterprise_30million_annual":
                "2026_enterprise_50million_annual",
            };
            const nextPlan = nextPlanMap[planType];
            if (nextPlan && plans[nextPlan] && plans[nextPlan].views) {
              return plans[nextPlan].views;
            }
            return 100000000; // fallback for highest enterprise plan (50M plan cap at 100M)
          }
        }
        // Legacy plans
        if (planType.includes("plus_500k")) return 1000000;
        if (planType.includes("enterprise")) return 10000000;
        if (isProPlanType(planType)) return 100000;
        if (planType.includes("plus")) return 500000;
        if (planType.includes("scale")) return 1000000;
        return Infinity; // No cap for other plans
      };

      // Check if current plan is selected and calculate current views
      const isCurrentPlan = current_plan.stripe_plan == plan.stripe_plan;
      let currentViews = 0;
      if (isCurrentPlan) {
        const currentQuantity =
          Math.floor(plan.views / 10000) + views_plan_quantity;
        currentViews = currentQuantity * 10000;
      }

      // Soft caps (e.g. Prime 90k) stay in place for new selections, but if
      // auto-scale already pushed quantity higher, raise the dropdown cap to match.
      const softViewsCap = getViewsCap(plan_type);
      const viewsCap =
        isCurrentPlan && currentViews > softViewsCap
          ? currentViews
          : softViewsCap;

      // Calculate maxQuantity based on cap or current value (whichever is higher)
      let maxQuantityFromCap = 101; // default
      if (softViewsCap !== Infinity) {
        // 2026 plans have specific caps
        if (plan_type.includes("2026_")) {
          if (isPersonalPlanType(plan_type)) {
            // For 2026_personal: quantity * 10000 <= 20000, so quantity <= 2
            maxQuantityFromCap = 2;
          } else if (isPrimePlanType(plan_type)) {
            // For 2026_prime: quantity * 10000 <= 90000, so quantity <= 9
            maxQuantityFromCap = 10;
          } else if (isProPlanType(plan_type)) {
            maxQuantityFromCap = Math.floor(softViewsCap / 10000) + 1;
          } else if (isPlus2MillionPlanType(plan_type)) {
            // For 2026_plus_2million: quantity * 10000 <= viewsCap (4M), so quantity <= 400
            maxQuantityFromCap = Math.floor(softViewsCap / 10000);
          } else if (isPlusPlanType(plan_type)) {
            // For 2026_plus: quantity * 10000 <= 490000, so quantity <= 49
            maxQuantityFromCap = 199;
          } else if (plan_type.includes("2026_enterprise")) {
            // For 2026_enterprise: calculate based on dynamic cap from next plan
            // quantity * 10000 <= viewsCap, so quantity <= viewsCap / 10000
            maxQuantityFromCap = Math.floor(softViewsCap / 10000);
          }
        } else {
          // Legacy plans
          if (plan_type.includes("plus_500k")) {
            maxQuantityFromCap = 99;
          } else if (plan_type.includes("enterprise")) {
            maxQuantityFromCap = 999;
          } else if (isProPlanType(plan_type)) {
            maxQuantityFromCap = 9;
          } else if (plan_type.includes("plus")) {
            maxQuantityFromCap = 49;
          } else if (plan_type.includes("scale")) {
            maxQuantityFromCap = 99;
          }
        }
      }

      // If current plan exceeds soft cap, extend dropdown through the current value
      let maxQuantityFromCurrent = 0;
      if (isCurrentPlan && currentViews > softViewsCap) {
        maxQuantityFromCurrent = Math.ceil(currentViews / 10000) + 1;
      }

      const maxQuantity = Math.max(
        maxQuantityFromCap,
        maxQuantityFromCurrent,
        isProPlanType(plan_type) && views_plan_quantity < 30
          ? 10
          : plan_type.includes("plus_2million") && views_plan_quantity < 101
          ? 76
          : plan_type.includes("plus") && views_plan_quantity < 21
          ? 30
          : maxQuantityFromCap
      );

      // Calculate current plan's quantity
      const quantityOffset = plan.views / 10000;
      const currentQuantity = isCurrentPlan
        ? Math.floor(plan.views / 10000) + views_plan_quantity
        : -1;

      // Collect all quantities that pass the filters
      let quantities = [...Array(maxQuantity).keys()]
        .filter((quantity) => quantity >= Math.floor(plan.views / 10000))
        .filter((quantity) => {
          if (viewsCap === Infinity) return true;
          const views = quantity * 10000;
          // Keep current selection visible if already over the soft cap
          if (isCurrentPlan && quantity === currentQuantity) return true;
          return views <= viewsCap;
        })
        .filter((quantity) => {
          // After 500k views, only show options in 100k increments (quantity increments of 10)
          const views = quantity * 10000;
          if (views > 500000) {
            // Only show quantities that are multiples of 10 (for 100k increments)
            return quantity % 10 === 0;
          }
          return true;
        });

      // If current plan's quantity doesn't match any milestone, add it
      if (
        isCurrentPlan &&
        currentQuantity >= 0 &&
        !quantities.includes(currentQuantity)
      ) {
        const currentViews = currentQuantity * 10000;
        // Only add if it's within reasonable bounds
        if (
          currentViews <= Math.max(viewsCap, currentViews) &&
          currentQuantity < maxQuantity
        ) {
          quantities.push(currentQuantity);
          quantities.sort((a, b) => a - b);
        }
      }

      quantities.forEach((quantity) => {
        const quantityOffset = plan.views / 10000;
        let quantityValue = quantity - quantityOffset;
        let quantityLabel;
        if (quantityValue < 0) {
          quantityValue = "";
          quantityLabel = plan.views.toLocaleString();
        } else {
          quantityLabel = (quantity * 10000).toLocaleString();
        }

        // select the current plan
        const optionSelected =
          current_plan.stripe_plan == plan.stripe_plan &&
          plan.views / 10000 + (views_plan_quantity - quantityOffset) ==
            quantityValue;

        const optionTag = `<option value="${quantityValue}" ${
          optionSelected ? "selected" : ""
        }>${quantityLabel} monthly funnel views</option>`;

        $(usageSelect).append(optionTag);
      });

      $(usageSelect).on("change", function () {
        const selectedValue = $(usageSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? Math.ceil(parseFloat(selectedValue) || 0)
            : 0;

        // Get current actions quantity from actions dropdown
        const actionsSelect = $(plan_div).find(".plan-actions-select");
        const actionsQuantity =
          actionsSelect.length > 0 && actionsSelect.val() !== "contact"
            ? Math.ceil(parseFloat(actionsSelect.val() || 0) || 0)
            : 0;

        // visualize price
        let price = plan.price;

        if (plan_type.includes("annual")) {
          price = Math.ceil(price / 12);
        }

        const annual_commit_discount = on_annual_paid_monthly == true;

        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }

        price = price + quantity * viewsPlan.price;

        // Add actions plan price if actions dropdown exists
        const actionsPlan = actionsPlans[plan.actions_plan];
        if (actionsPlan && actionsQuantity >= 0) {
          price = price + actionsQuantity * actionsPlan.price;
        }

        const downgrade_inaccessible_on_contract =
          (annual_commit_discount &&
            price < current_plan.price + views_plan_quantity * 20) ||
          ([
            "2026_scale",
            "2026_enterprise",
            "2025_scale",
            "2025_enterprise",
          ].includes(current_plan.plan_type) &&
            ![
              "2026_scale",
              "2026_enterprise",
              "2025_scale",
              "2025_enterprise",
            ].includes(plan.plan_type));

        $(priceLabel).html(price.toLocaleString());

        // build button
        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;

        if (
          checkoutLinkUsesTrial({
            planType: plan_type,
            freePlan: free_plan,
            trial,
            onAnnualPaidMonthly: on_annual_paid_monthly,
          })
        ) {
          buttonLink += "&trial=true";
        }

        if (quantity >= 0) {
          buttonLink += `&views_plan_quantity=${quantity}`;
        }

        if (actionsQuantity >= 0) {
          buttonLink += `&actions_plan_quantity=${actionsQuantity}`;
        }

        if (on_annual_paid_monthly == true) {
          buttonLink += "&annual_paid_monthly=true";
        }

        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";

        const buttonText =
          plan_type == subscription.stripe_plan &&
          quantity == views_plan_quantity &&
          !downgrade_inaccessible_on_contract
            ? "Current Plan"
            : downgrade_inaccessible_on_contract
            ? "Account ineligible"
            : free_plan
            ? "Get Started →"
            : "Switch to this plan";

        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan &&
            (plan_type == "2025_pro" || isProPlanType(plan_type))) ||
          (current_plan.stripe_plan == "2026_pro" &&
            plan_type == "2026_plus") ||
          (current_plan.stripe_plan == "2025_plus" && plan_type == "2025_scale")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
            ? "rgb(126, 147, 165)"
            : "";
        $(buttonTag).css("background", backgroundColor);

        // disable button if on annual contract and plan would be downgrade
        if (
          downgrade_inaccessible_on_contract ||
          buttonText == "Current Plan"
        ) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        // show contact us button if interested in high traffic
        if (
          selectedValue == "contact" &&
          [
            "free",
            "2026_personal",
            "2026_pro",
            "2026_plus",
            "2026_plus_2million",
            "2025_pro",
            "2025_plus",
            "2025_scale",
          ].includes(current_plan.plan_type)
        ) {
          $(buttonTag).removeClass("disabled");
          buttonTag.innerHTML = "Contact Sales";
          buttonLinkTag.href = "#";

          $(buttonLinkTag)
            .off("click")
            .on("click", function () {
              contactUsButton();
            });
        }

        // Free Pro uses a hardcoded trial CTA outside .plan-button
        if (planOuterDiv.length) {
          $(buttonLinkTag).append(buttonTag);
          $(planOuterDiv).html(buttonLinkTag);
        }

        if (
          (plan.annual_plan || isAnnualPlan) &&
          !on_annual_paid_monthly &&
          !downgrade_inaccessible_on_contract &&
          planOuterDiv.length
        ) {
          let annualLink = `${root_url}subscriptions/new?stripe_plan=${plan.annual_plan}&account_id=${subscription.account_id}`;

          if (quantity >= 0) {
            annualLink += `&views_plan_quantity=${quantity}`;
          }

          if (current_plan.stripe_plan == plan.annual_plan) {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                You're getting 2 months free by paying yearly 🙌
              </p>`
            );
          } else if (isAnnualPlan && plan_type != "2026_plus_2million_annual") {
            const monthlyPlan = plans[plan_type.replace("_annual", "")];

            if (monthlyPlan) {
              $(planOuterDiv).append(
                `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                  90-day money back guarantee
                </p>`
              );
            }
          } else {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important;">
                <a class="annual-link" style="color: #2bc3a6 !important;" href="#">
                  2 months free with annual →
                </a>
              </p>`
            );
          }
          $(planOuterDiv)
            .find(".annual-link")
            .on("click", function (e) {
              e.preventDefault();
              $('a[href="#annual"]').trigger("click");
            });
        }
      });

      // Trigger actions dropdown change when views dropdown changes (for 2026+ plans)
      const actionsSelect = $(plan_div).find(".plan-actions-select");
      if (actionsSelect.length > 0) {
        $(usageSelect).on("change", function () {
          $(actionsSelect).trigger("change");
        });
      }

      $(usageSelect).trigger("change");
    });
  });

  // build actions dropdown for 2026+ plans
  var actionsBuilderPlanTypes = [
    "2026_personal",
    "2026_personal_annual",
    "2026_shopify_personal",
    "2026_prime",
    "2026_prime_annual",
    "2026_shopify_prime",
    "2026_pro",
    "2026_pro_annual",
    "2026_shopify_pro",
    "2026_plus",
    "2026_plus_annual",
    "2026_shopify_plus",
    "2026_plus_2million",
    "2026_plus_2million_annual",
    "2026_shopify_plus_2million",
    "2026_enterprise",
    "2026_enterprise_annual",
    "2026_enterprise_8million",
    "2026_enterprise_8million_annual",
    "2026_enterprise_15million",
    "2026_enterprise_15million_annual",
    "2026_enterprise_30million",
    "2026_enterprise_30million_annual",
    "2026_enterprise_50million",
    "2026_enterprise_50million_annual",
  ];

  $(".pricing-box-outer[data-plan]").each(function () {
    var planType = $(this).attr("data-plan");
    if (
      planType &&
      actionsBuilderPlanTypes.indexOf(planType) === -1 &&
      planType.indexOf("2026_") === 0 &&
      plans[planType] &&
      plans[planType].actions_plan
    ) {
      actionsBuilderPlanTypes.push(planType);
    }
  });

  $(actionsBuilderPlanTypes).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const actionsOuterDiv = $(plan_div).find(".plan-actions-select-outer");
      if (actionsOuterDiv.length === 0) return;

      const actionsOuterDivContent =
        '<select class="field-control text-field plan-actions-select"></select>';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const plan = plans[plan_type];
      if (!plan) {
        return;
      }
      const actionsPlan = actionsPlans[plan.actions_plan];
      const isAnnualPlan = plan_type.indexOf("annual") > -1;

      if (!actionsPlan) return;

      // build actions volume dropdown
      $(actionsOuterDiv).html(actionsOuterDivContent);

      const actionsSelect = $(actionsOuterDiv).find("select");

      // Determine actions cap based on plan type
      const getActionsCap = (planType) => {
        // 2026 plans have specific caps
        if (planType.includes("2026_")) {
          if (isPersonalPlanType(planType)) return 10000;
          // Cap below Pro included (10k actions) — beyond this Prime costs more than Pro
          if (isPrimePlanType(planType)) return 9000;
          if (isProPlanType(planType)) return 30000;
          if (isPlus2MillionPlanType(planType)) return 400000;
          if (isPlusPlanType(planType)) return 200000;
          // For enterprise plans, use the next plan up's actions as the cap
          if (planType.includes("2026_enterprise")) {
            const nextPlanMap = {
              "2026_enterprise": "2026_enterprise_8million",
              "2026_enterprise_annual": "2026_enterprise_8million_annual",
              "2026_enterprise_8million": "2026_enterprise_15million",
              "2026_enterprise_8million_annual":
                "2026_enterprise_15million_annual",
              "2026_enterprise_15million": "2026_enterprise_30million",
              "2026_enterprise_15million_annual":
                "2026_enterprise_30million_annual",
              "2026_enterprise_30million": "2026_enterprise_50million",
              "2026_enterprise_30million_annual":
                "2026_enterprise_50million_annual",
            };
            const nextPlan = nextPlanMap[planType];
            if (nextPlan && plans[nextPlan] && plans[nextPlan].actions) {
              return plans[nextPlan].actions;
            }
            return 10000000; // fallback for highest enterprise plan (50M plan: 10M actions)
          }
        }
        // Legacy plans
        if (planType.includes("plus_500k")) return 200000;
        if (planType.includes("enterprise")) return 2000000;
        if (isProPlanType(planType)) return 20000;
        if (planType.includes("plus")) return 100000;
        if (planType.includes("scale")) return 200000;
        return Infinity; // No cap for other plans
      };

      // Check if current plan is selected and calculate current actions
      const isCurrentPlan = current_plan.stripe_plan == plan.stripe_plan;
      let currentActions = 0;
      if (isCurrentPlan) {
        const currentQuantity =
          Math.floor(plan.actions / 1000) + actions_plan_quantity;
        currentActions = currentQuantity * 1000;
      }

      // Soft caps (e.g. Prime 9k) stay in place for new selections, but if
      // auto-scale already pushed quantity higher, raise the dropdown cap to match.
      const softActionsCap = getActionsCap(plan_type);
      const actionsCap =
        isCurrentPlan && currentActions > softActionsCap
          ? currentActions
          : softActionsCap;

      // Calculate maxQuantity based on cap or current value (whichever is higher)
      let maxQuantityFromCap = 101; // default
      if (softActionsCap !== Infinity) {
        // 2026 plans have specific caps
        if (plan_type.includes("2026_")) {
          if (isPersonalPlanType(plan_type)) {
            maxQuantityFromCap = 10;
          } else if (isPrimePlanType(plan_type)) {
            // For 2026_prime: quantity * 1000 <= 9000, so quantity <= 9
            maxQuantityFromCap = 10;
          } else if (isProPlanType(plan_type)) {
            // For 2026_pro: quantity * 1000 <= 30000, so quantity <= 30
            maxQuantityFromCap = 31;
          } else if (isPlus2MillionPlanType(plan_type)) {
            // For 2026_plus_2million: quantity * 1000 <= 400000, so quantity <= 400
            maxQuantityFromCap = 399;
          } else if (isPlusPlanType(plan_type)) {
            // For 2026_plus: quantity * 1000 <= 200000, so quantity <= 200
            maxQuantityFromCap = 199;
          } else if (plan_type.includes("2026_enterprise")) {
            // For 2026_enterprise: calculate based on dynamic cap from next plan
            // quantity * 1000 <= actionsCap, so quantity <= actionsCap / 1000
            maxQuantityFromCap = Math.floor(softActionsCap / 1000) + 1;
          }
        } else {
          // Legacy plans
          if (plan_type.includes("plus_500k")) {
            maxQuantityFromCap = 199;
          } else if (plan_type.includes("enterprise")) {
            maxQuantityFromCap = 1999;
          } else if (isProPlanType(plan_type)) {
            maxQuantityFromCap = 19;
          } else if (plan_type.includes("plus")) {
            maxQuantityFromCap = 99;
          } else if (plan_type.includes("scale")) {
            maxQuantityFromCap = 199;
          }
        }
      }

      // If current plan exceeds soft cap, extend dropdown through the current value
      let maxQuantityFromCurrent = 0;
      if (isCurrentPlan && currentActions > softActionsCap) {
        maxQuantityFromCurrent = Math.ceil(currentActions / 1000) + 1;
      }

      const maxQuantity = Math.max(maxQuantityFromCap, maxQuantityFromCurrent);

      // Calculate current plan's quantity for actions
      const actionsQuantityOffset = plan.actions / 1000;
      const currentActionsQuantity = isCurrentPlan
        ? Math.floor(plan.actions / 1000) + actions_plan_quantity
        : -1;

      // Collect all quantities that pass the filters
      let actionQuantities = [...Array(maxQuantity).keys()]
        .filter((quantity) => quantity >= Math.floor(plan.actions / 1000))
        .filter((quantity) => {
          if (actionsCap === Infinity) return true;
          const actions = quantity * 1000;
          // Keep current selection visible if already over the soft cap
          if (isCurrentPlan && quantity === currentActionsQuantity) return true;
          return actions <= actionsCap;
        })
        .filter((quantity) => {
          // After 20k actions, only show options in 10k increments (quantity increments of 10)
          // After 1 million actions, only show options in 100k increments (quantity increments of 100)
          const actions = quantity * 1000;
          if (actions > 1000000) {
            // Only show quantities that are multiples of 100 (for 100k increments)
            return quantity % 100 === 0;
          }
          if (actions > 20000) {
            // Only show quantities that are multiples of 10 (for 10k increments)
            return quantity % 10 === 0;
          }
          return true;
        });

      // If current plan's quantity doesn't match any milestone, add it
      if (
        isCurrentPlan &&
        currentActionsQuantity >= 0 &&
        !actionQuantities.includes(currentActionsQuantity)
      ) {
        const currentActionsValue = currentActionsQuantity * 1000;
        // Only add if it's within reasonable bounds
        if (
          currentActionsValue <= Math.max(actionsCap, currentActionsValue) &&
          currentActionsQuantity < maxQuantity
        ) {
          actionQuantities.push(currentActionsQuantity);
          actionQuantities.sort((a, b) => a - b);
        }
      }

      actionQuantities.forEach((quantity) => {
        let quantityValue = quantity - actionsQuantityOffset;
        let quantityLabel;
        if (quantityValue < 0) {
          quantityValue = "";
          quantityLabel = plan.actions.toLocaleString();
        } else {
          quantityLabel = (quantity * 1000).toLocaleString();
        }

        // select the current plan
        const optionSelected =
          current_plan.stripe_plan == plan.stripe_plan &&
          plan.actions / 1000 +
            (actions_plan_quantity - actionsQuantityOffset) ==
            quantityValue;

        const optionTag = `<option value="${quantityValue}" ${
          optionSelected ? "selected" : ""
        }>${quantityLabel} monthly billable actions</option>`;

        $(actionsSelect).append(optionTag);
      });

      $(actionsSelect).on("change", function () {
        const selectedValue = $(actionsSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? Math.ceil(parseFloat(selectedValue) || 0)
            : 0;

        // Get current views quantity from views dropdown
        const viewsSelect = $(plan_div).find(".plan-views-select");
        const viewsQuantity =
          viewsSelect.length > 0 && viewsSelect.val() !== "contact"
            ? Math.ceil(parseFloat(viewsSelect.val() || 0) || 0)
            : 0;

        // visualize price
        let price = plan.price;

        if (plan_type.includes("annual")) {
          price = Math.ceil(price / 12);
        }

        const annual_commit_discount = on_annual_paid_monthly == true;

        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }

        // Add views plan price
        const viewsPlan = viewsPlans[plan.views_plan];
        if (viewsPlan && viewsQuantity >= 0) {
          price = price + viewsQuantity * viewsPlan.price;
        }

        // Add actions plan price
        if (actionsPlan && quantity >= 0) {
          price = price + quantity * actionsPlan.price;
        }

        const downgrade_inaccessible_on_contract =
          (annual_commit_discount &&
            price < current_plan.price + views_plan_quantity * 20) ||
          ([
            "2026_scale",
            "2026_enterprise",
            "2025_scale",
            "2025_enterprise",
          ].includes(current_plan.plan_type) &&
            ![
              "2026_scale",
              "2026_enterprise",
              "2025_scale",
              "2025_enterprise",
            ].includes(plan.plan_type));

        $(priceLabel).html(price.toLocaleString());

        // build button
        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;

        if (
          checkoutLinkUsesTrial({
            planType: plan_type,
            freePlan: free_plan,
            trial,
            onAnnualPaidMonthly: on_annual_paid_monthly,
          })
        ) {
          buttonLink += "&trial=true";
        }

        if (viewsQuantity >= 0) {
          buttonLink += `&views_plan_quantity=${viewsQuantity}`;
        }

        if (quantity >= 0) {
          buttonLink += `&actions_plan_quantity=${quantity}`;
        }

        if (on_annual_paid_monthly == true) {
          buttonLink += "&annual_paid_monthly=true";
        }

        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";

        const buttonText =
          plan_type == subscription.stripe_plan &&
          viewsQuantity == views_plan_quantity &&
          quantity == actions_plan_quantity &&
          !downgrade_inaccessible_on_contract
            ? "Current Plan"
            : downgrade_inaccessible_on_contract
            ? "Account ineligible"
            : free_plan
            ? "Get Started →"
            : "Switch to this plan";

        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan &&
            (plan_type == "2025_pro" || isProPlanType(plan_type))) ||
          (current_plan.stripe_plan == "2026_pro" &&
            plan_type == "2026_plus") ||
          (current_plan.stripe_plan == "2025_plus" && plan_type == "2025_scale")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
            ? "rgb(126, 147, 165)"
            : "";
        $(buttonTag).css("background", backgroundColor);

        // disable button if on annual contract and plan would be downgrade
        if (
          downgrade_inaccessible_on_contract ||
          buttonText == "Current Plan"
        ) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        // show contact us button if interested in high traffic
        if (
          selectedValue == "contact" &&
          [
            "free",
            "2026_personal",
            "2026_pro",
            "2026_plus",
            "2026_plus_2million",
            "2025_pro",
            "2025_plus",
            "2025_scale",
          ].includes(current_plan.plan_type)
        ) {
          $(buttonTag).removeClass("disabled");
          buttonTag.innerHTML = "Contact Sales";
          buttonLinkTag.href = "#";

          $(buttonLinkTag)
            .off("click")
            .on("click", function () {
              contactUsButton();
            });
        }

        if (planOuterDiv.length) {
          $(buttonLinkTag).append(buttonTag);
          $(planOuterDiv).html(buttonLinkTag);
        }

        if (
          (plan.annual_plan || isAnnualPlan) &&
          !on_annual_paid_monthly &&
          !downgrade_inaccessible_on_contract &&
          planOuterDiv.length
        ) {
          let annualLink = `${root_url}subscriptions/new?stripe_plan=${plan.annual_plan}&account_id=${subscription.account_id}`;

          if (viewsQuantity >= 0) {
            annualLink += `&views_plan_quantity=${viewsQuantity}`;
          }

          if (quantity >= 0) {
            annualLink += `&actions_plan_quantity=${quantity}`;
          }

          if (current_plan.stripe_plan == plan.annual_plan) {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                You're getting 2 months free by paying yearly 🙌
              </p>`
            );
          } else if (isAnnualPlan && plan_type != "2026_plus_2million_annual") {
            const monthlyPlan = plans[plan_type.replace("_annual", "")];

            if (monthlyPlan) {
              $(planOuterDiv).append(
                `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                  90-day money back guarantee
                </p>`
              );
            }
          } else {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important;">
                <a class="annual-link" style="color: #2bc3a6 !important;" href="#">
                  2 months free with annual →
                </a>
              </p>`
            );
          }
          $(planOuterDiv)
            .find(".annual-link")
            .on("click", function (e) {
              e.preventDefault();
              $('a[href="#annual"]').trigger("click");
            });
        }
      });

      // Trigger change on views dropdown to update actions dropdown
      const viewsSelect = $(plan_div).find(".plan-views-select");
      if (viewsSelect.length > 0) {
        viewsSelect.on("change", function () {
          $(actionsSelect).trigger("change");
        });
      }

      $(actionsSelect).trigger("change");
    });
  });

  // 2024+ pricing plans

  $([
    "2024_pages",
    "2024_pages_annual",
    "2024_shopify_pages",
    "2024_core",
    "2024_core_annual",
    "2024_shopify_core",
    "2024_funnels",
    "2024_funnels_annual",
    "2024_shopify_funnels",
    "2024_pro",
    "2024_pro_annual",
    "2024_shopify_pro",
    "2024_plus",
    "2024_plus_annual",
    "2024_shopify_plus",
    "2024_advanced",
    "2024_advanced_annual",
    "2024_shopify_advanced",
    "2024_scale",
    "2024_scale_annual",
    "2024_shopify_scale",
    "2024_scale_managed",
    "2024_scale_managed_annual",
    "2024_shopify_scale_managed",
  ]).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const usageOuterDiv = $(plan_div).find(".plan-usage-select-outer");
      const usageOuterDivContent =
        '<select class="field-control text-field plan-usage-select" style="width: 100%;"></select>';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const buttonWrapper = $(plan_div).find(".plan-button");
      const plan = plans[plan_type];
      const viewsPlan = viewsPlans[plan.views_plan];
      const isAnnualPlan = plan_type.indexOf("annual") > -1;

      // build views volume dropdown
      $(usageOuterDiv).html(usageOuterDivContent);

      const usageSelect = $(usageOuterDiv).find("select");
      const maxQuantity =
        plan_type.includes("personal") && views_plan_quantity < 10
          ? 10
          : plan_type.includes("core") && views_plan_quantity < 20
          ? 10
          : isProPlanType(plan_type) && views_plan_quantity < 30
          ? 17
          : plan_type.includes("plus") && views_plan_quantity < 21
          ? 49
          : 101;

      [...Array(maxQuantity).keys()]
        .filter((quantity) => quantity >= plan.views / 10000)
        .forEach((quantity) => {
          const quantityOffset = plan.views / 10000;
          const quantityLabel = (quantity * 10000).toLocaleString();

          let quantityValue = quantity - quantityOffset;
          if (quantityValue < 0) {
            quantityValue = "";
          }

          // select the current plan
          const optionSelected =
            current_plan.stripe_plan == plan.stripe_plan &&
            plan.views / 10000 + (views_plan_quantity - quantityOffset) ==
              quantityValue;

          const optionTag = `<option value="${quantityValue}" ${
            optionSelected ? "selected" : ""
          }>${quantityLabel} monthly funnel views</option>`;

          $(usageSelect).append(optionTag);
        });

      $(usageSelect).on("change", function () {
        const selectedValue = $(usageSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? parseInt(selectedValue)
            : 0;

        // Get current actions quantity from actions dropdown
        const actionsSelect = $(plan_div).find(".plan-actions-select");
        const actionsQuantity =
          actionsSelect.length > 0 && actionsSelect.val() !== "contact"
            ? Math.ceil(parseFloat(actionsSelect.val() || 0) || 0)
            : 0;

        // visualize price
        let price = plan.price;

        if (plan_type.includes("annual")) {
          price = Math.ceil(price / 12);
        }

        const annual_commit_discount = on_annual_paid_monthly == true;

        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }

        price = price + quantity * viewsPlan.price;

        // Add actions plan price if actions dropdown exists
        const actionsPlan = plan.actions_plan
          ? actionsPlans[plan.actions_plan]
          : null;
        if (actionsPlan && actionsQuantity >= 0) {
          price = price + actionsQuantity * actionsPlan.price;
        }

        const downgrade_inaccessible_on_contract =
          (annual_commit_discount &&
            price < current_plan.price + views_plan_quantity * 20) ||
          ["2024_scale", "2024_enterprise"].includes(current_plan.plan_type);

        $(priceLabel).html(price.toLocaleString());

        // build button
        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;

        if (
          ((free_plan && !trial) || (trial && !free_plan)) &&
          on_annual_paid_monthly !== true &&
          !isAnnualPlan
        ) {
          buttonLink += "&trial=true";
        }

        if (quantity >= 0) {
          buttonLink += `&views_plan_quantity=${quantity}`;
        }

        if (actionsQuantity >= 0) {
          buttonLink += `&actions_plan_quantity=${actionsQuantity}`;
        }

        if (on_annual_paid_monthly == true) {
          buttonLink += "&annual_paid_monthly=true";
        }

        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";

        const buttonText =
          free_plan && !trial && !isAnnualPlan
            ? "Start Free Trial →"
            : plan_type == subscription.stripe_plan &&
              quantity == views_plan_quantity &&
              (actionsSelect.length === 0 ||
                actionsQuantity == actions_plan_quantity) &&
              !downgrade_inaccessible_on_contract
            ? "Current Plan"
            : downgrade_inaccessible_on_contract
            ? "Account ineligible"
            : "Switch to this plan";

        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan && plan_type == "2024_pages") ||
          (current_plan.stripe_plan == "2024_pages" &&
            plan_type == "2024_core") ||
          (current_plan.stripe_plan == "2024_core" &&
            plan_type == "2024_pro") ||
          (current_plan.stripe_plan == "2024_pro" &&
            plan_type == "2024_plus") ||
          (current_plan.stripe_plan == "2024_pro" &&
            plan_type == "2024_advanced") ||
          (current_plan.stripe_plan == "2024_plus" &&
            plan_type == "2024_scale") ||
          (current_plan.stripe_plan == "2024_advanced" &&
            plan_type == "2024_scale") ||
          ((current_plan.stripe_plan == "2024_scale" ||
            current_plan.stripe_plan == "2024_scale_managed") &&
            plan_type == "2024_enterprise")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
            ? "rgb(126, 147, 165)"
            : "";
        $(buttonTag).css("background", backgroundColor);

        // disable button if on annual contract and plan would be downgrade
        if (
          downgrade_inaccessible_on_contract ||
          buttonText == "Current Plan"
        ) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        // show contact us button if interested in high traffic
        if (
          selectedValue == "contact" &&
          [
            "free",
            "2024_pages",
            "2024_funnels",
            "2024_core",
            "2024_pages",
            "2024_scale",
          ].includes(current_plan.plan_type)
        ) {
          $(buttonTag).removeClass("disabled");
          buttonTag.innerHTML = "Contact Sales";
          buttonLinkTag.href = "#";

          $(buttonLinkTag)
            .off("click")
            .on("click", function () {
              contactUsButton();
            });
        }

        $(buttonLinkTag).append(buttonTag);
        $(planOuterDiv).html(buttonLinkTag);

        if (
          (plan.annual_plan || isAnnualPlan) &&
          !on_annual_paid_monthly &&
          !downgrade_inaccessible_on_contract
        ) {
          let annualLink = `${root_url}subscriptions/new?stripe_plan=${plan.annual_plan}&account_id=${subscription.account_id}`;

          if (quantity >= 0) {
            annualLink += `&views_plan_quantity=${quantity}`;
          }

          if (actionsQuantity >= 0) {
            annualLink += `&actions_plan_quantity=${actionsQuantity}`;
          }

          if (current_plan.stripe_plan == plan.annual_plan) {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                You're saving 25% by paying yearly 🙌
              </p>`
            );
          } else if (isAnnualPlan) {
            const monthlyPlan = plans[plan_type.replace("_annual", "")];

            if (monthlyPlan) {
              $(planOuterDiv).append(
                `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                  90-day money back guarantee
                </p>`
              );
            }
          } else {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important;">
                <a class="annual-link" style="color: #2bc3a6 !important;" href="#">
                  25% discount with annual →
                </a>
              </p>`
            );
          }
          $(planOuterDiv)
            .find(".annual-link")
            .on("click", function (e) {
              e.preventDefault();
              $('a[href="#annual"]').trigger("click");
            });
        }
      });

      $(usageSelect).trigger("change");
    });
  });

  // build actions dropdown for 2024 plans
  $([
    "2024_pages",
    "2024_pages_annual",
    "2024_core",
    "2024_core_annual",
    "2024_funnels",
    "2024_funnels_annual",
    "2024_pro",
    "2024_pro_annual",
    "2024_plus",
    "2024_plus_annual",
    "2024_advanced",
    "2024_advanced_annual",
    "2024_scale",
    "2024_scale_annual",
    "2024_scale_managed",
    "2024_scale_managed_annual",
  ]).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const actionsOuterDiv = $(plan_div).find(".plan-actions-select-outer");
      if (actionsOuterDiv.length === 0) return;

      const plan = plans[plan_type];
      const actionsPlan = plan.actions_plan
        ? actionsPlans[plan.actions_plan]
        : null;
      if (!actionsPlan) return;

      const viewsPlan = viewsPlans[plan.views_plan];
      const actionsOuterDivContent =
        '<select class="field-control text-field plan-actions-select" style="width: 100%;"></select>';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const usageSelect = $(plan_div).find(".plan-usage-select");
      const isAnnualPlan = plan_type.indexOf("annual") > -1;

      $(actionsOuterDiv).html(actionsOuterDivContent);

      const actionsSelect = $(actionsOuterDiv).find("select");

      const getActionsCap = (planType) => {
        if (planType.includes("2024_scale_managed")) return 200000;
        if (planType.includes("2024_scale")) return 100000;
        if (planType.includes("2024_enterprise")) return 2000000;
        if (planType.includes("2024_plus") || planType.includes("2024_advanced"))
          return 100000;
        if (planType.includes("2024_pro")) return 20000;
        if (planType.includes("2024_core")) return 10000;
        if (planType.includes("2024_pages") || planType.includes("2024_funnels"))
          return 5000;
        return Infinity;
      };

      const actionsCap = getActionsCap(plan_type);
      const isCurrentPlan = current_plan.stripe_plan == plan.stripe_plan;
      const actionsQuantityOffset = plan.actions / 1000;
      const currentActionsQuantity = isCurrentPlan
        ? Math.floor(plan.actions / 1000) + actions_plan_quantity
        : -1;

      let maxQuantity = 101;
      if (actionsCap !== Infinity) {
        maxQuantity = Math.floor(actionsCap / 1000) + 1;
      }
      if (
        isCurrentPlan &&
        currentActionsQuantity >= 0 &&
        currentActionsQuantity >= maxQuantity
      ) {
        maxQuantity = currentActionsQuantity + 2;
      }

      const actionQuantities = [...Array(maxQuantity).keys()]
        .filter((q) => q >= Math.floor(plan.actions / 1000))
        .filter((q) => {
          if (actionsCap !== Infinity) {
            return q * 1000 <= actionsCap;
          }
          return true;
        })
        .filter((q) => {
          const actions = q * 1000;
          if (actions > 20000) return q % 10 === 0;
          return true;
        });

      if (
        isCurrentPlan &&
        currentActionsQuantity >= 0 &&
        !actionQuantities.includes(currentActionsQuantity)
      ) {
        actionQuantities.push(currentActionsQuantity);
        actionQuantities.sort((a, b) => a - b);
      }

      actionQuantities.forEach((quantity) => {
        const quantityValue = quantity - actionsQuantityOffset;
        const quantityLabel =
          quantityValue < 0
            ? plan.actions.toLocaleString()
            : (quantity * 1000).toLocaleString();

        const optionSelected =
          isCurrentPlan &&
          plan.actions / 1000 +
            (actions_plan_quantity - actionsQuantityOffset) ===
            quantityValue;

        const optionTag = `<option value="${quantityValue < 0 ? "" : quantityValue}" ${
          optionSelected ? "selected" : ""
        }>${quantityLabel} monthly billable actions</option>`;

        $(actionsSelect).append(optionTag);
      });

      $(actionsSelect).on("change", function () {
        // Trigger views dropdown change to recalculate price and rebuild button
        if (usageSelect.length > 0) {
          usageSelect.trigger("change");
        }
      });

      $(actionsSelect).trigger("change");
    });
  });

  // build actions dropdown for 2025 plans (non-Shopify only)
  $([
    "2025_pro",
    "2025_pro_annual",
    "2025_plus",
    "2025_plus_annual",
    "2025_scale",
    "2025_scale_annual",
  ]).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const actionsOuterDiv = $(plan_div).find(".plan-actions-select-outer");
      if (actionsOuterDiv.length === 0) return;

      const plan = plans[plan_type];
      const actionsPlan = plan.actions_plan
        ? actionsPlans[plan.actions_plan]
        : null;
      if (!actionsPlan) return;

      const viewsPlan = viewsPlans[plan.views_plan];
      const actionsOuterDivContent =
        '<select class="field-control text-field plan-actions-select" style="width: 100%;"></select>';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const isAnnualPlan = plan_type.indexOf("annual") > -1;

      $(actionsOuterDiv).html(actionsOuterDivContent);

      const actionsSelect = $(actionsOuterDiv).find("select");

      const getActionsCap = (planType) => {
        if (planType.includes("2025_scale")) return 200000;
        if (planType.includes("2025_plus")) return 100000;
        if (planType.includes("2025_pro")) return 20000;
        return Infinity;
      };

      const actionsCap = getActionsCap(plan_type);
      const isCurrentPlan = current_plan.stripe_plan == plan.stripe_plan;
      const actionsQuantityOffset = plan.actions / 1000;
      const currentActionsQuantity = isCurrentPlan
        ? Math.floor(plan.actions / 1000) + actions_plan_quantity
        : -1;

      let maxQuantity = 101;
      if (actionsCap !== Infinity) {
        maxQuantity = Math.floor(actionsCap / 1000) + 1;
      }
      if (
        isCurrentPlan &&
        currentActionsQuantity >= 0 &&
        currentActionsQuantity >= maxQuantity
      ) {
        maxQuantity = currentActionsQuantity + 2;
      }

      const actionQuantities = [...Array(maxQuantity).keys()]
        .filter((q) => q >= Math.floor(plan.actions / 1000))
        .filter((q) => {
          if (actionsCap !== Infinity) {
            return q * 1000 <= actionsCap;
          }
          return true;
        })
        .filter((q) => {
          const actions = q * 1000;
          if (actions > 20000) return q % 10 === 0;
          return true;
        });

      if (
        isCurrentPlan &&
        currentActionsQuantity >= 0 &&
        !actionQuantities.includes(currentActionsQuantity)
      ) {
        actionQuantities.push(currentActionsQuantity);
        actionQuantities.sort((a, b) => a - b);
      }

      actionQuantities.forEach((quantity) => {
        const quantityValue = quantity - actionsQuantityOffset;
        const quantityLabel =
          quantityValue < 0
            ? plan.actions.toLocaleString()
            : (quantity * 1000).toLocaleString();

        const optionSelected =
          isCurrentPlan &&
          plan.actions / 1000 +
            (actions_plan_quantity - actionsQuantityOffset) ===
            quantityValue;

        const optionTag = `<option value="${quantityValue < 0 ? "" : quantityValue}" ${
          optionSelected ? "selected" : ""
        }>${quantityLabel} monthly billable actions</option>`;

        $(actionsSelect).append(optionTag);
      });

      $(actionsSelect).on("change", function () {
        const selectedValue = $(actionsSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? Math.ceil(parseFloat(selectedValue) || 0)
            : 0;

        const viewsSelect = $(plan_div).find(".plan-views-select");
        const viewsQuantity =
          viewsSelect.length > 0 && viewsSelect.val() !== "contact"
            ? Math.ceil(parseFloat(viewsSelect.val() || 0) || 0)
            : 0;

        let price = plan.price;
        if (plan_type.includes("annual")) {
          price = Math.ceil(price / 12);
        }
        const annual_commit_discount = on_annual_paid_monthly == true;
        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }
        if (viewsPlan && viewsQuantity >= 0) {
          price = price + viewsQuantity * viewsPlan.price;
        }
        if (actionsPlan && quantity >= 0) {
          price = price + quantity * actionsPlan.price;
        }

        const downgrade_inaccessible_on_contract =
          (annual_commit_discount &&
            price < current_plan.price + views_plan_quantity * 20) ||
          (["2025_scale", "2025_enterprise"].includes(
            current_plan.plan_type
          ) &&
            !["2025_scale", "2025_enterprise"].includes(plan.plan_type));

        $(priceLabel).html(price.toLocaleString());

        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;
        if (viewsQuantity >= 0) {
          buttonLink += `&views_plan_quantity=${viewsQuantity}`;
        }
        if (quantity >= 0) {
          buttonLink += `&actions_plan_quantity=${quantity}`;
        }
        if (on_annual_paid_monthly == true) {
          buttonLink += "&annual_paid_monthly=true";
        }
        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";
        const buttonText =
          plan_type == subscription.stripe_plan &&
          viewsQuantity == views_plan_quantity &&
          quantity == actions_plan_quantity &&
          !downgrade_inaccessible_on_contract
            ? "Current Plan"
            : downgrade_inaccessible_on_contract
              ? "Account ineligible"
              : "Switch to this plan";
        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan &&
            (plan_type == "2025_pro" || isProPlanType(plan_type))) ||
          (current_plan.stripe_plan == "2025_plus" &&
            plan_type == "2025_scale")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
              ? "rgb(126, 147, 165)"
              : "";
        $(buttonTag).css("background", backgroundColor);

        if (
          downgrade_inaccessible_on_contract ||
          buttonText == "Current Plan"
        ) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        $(buttonLinkTag).append(buttonTag);
        $(planOuterDiv).html(buttonLinkTag);

        if (
          (plan.annual_plan || isAnnualPlan) &&
          !on_annual_paid_monthly &&
          !downgrade_inaccessible_on_contract
        ) {
          let annualLink = `${root_url}subscriptions/new?stripe_plan=${plan.annual_plan}&account_id=${subscription.account_id}`;
          if (viewsQuantity >= 0) {
            annualLink += `&views_plan_quantity=${viewsQuantity}`;
          }
          if (quantity >= 0) {
            annualLink += `&actions_plan_quantity=${quantity}`;
          }
          if (current_plan.stripe_plan == plan.annual_plan) {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                You're getting 2 months free by paying yearly 🙌
              </p>`
            );
          } else if (isAnnualPlan) {
            const monthlyPlan = plans[plan_type.replace("_annual", "")];
            if (monthlyPlan) {
              $(planOuterDiv).append(
                `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                  90-day money back guarantee
                </p>`
              );
            }
          } else {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important;">
                <a class="annual-link" style="color: #2bc3a6 !important;" href="#">
                  2 months free with annual →
                </a>
              </p>`
            );
          }
          $(planOuterDiv)
            .find(".annual-link")
            .on("click", function (e) {
              e.preventDefault();
              $('a[href="#annual"]').trigger("click");
            });
        }
      });

      const viewsSelect = $(plan_div).find(".plan-views-select");
      if (viewsSelect.length > 0) {
        viewsSelect.on("change", function () {
          $(actionsSelect).trigger("change");
        });
      }

      $(actionsSelect).trigger("change");
    });
  });

  // 2023 pricing plans

  $(["2023_build", "2023_launch", "2023_pro", "2023_scale"]).each(function (
    i,
    plan_type
  ) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const usageOuterDiv = $(plan_div).find(".plan-usage-select-outer");
      const usageOuterDivContent =
        'For <select class="field-control text-field plan-usage-select"></select> monthly views';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const buttonWrapper = $(plan_div).find(".plan-button");
      const plan = plans[plan_type];
      const viewsPlan = viewsPlans[plan.views_plan];

      // build views volume dropdown
      $(usageOuterDiv).html(usageOuterDivContent);
      const usageSelect = $(usageOuterDiv).find("select");

      [...Array(60).keys()]
        .filter((quantity) => quantity >= plan.views / 10000)
        .forEach((quantity) => {
          const quantityOffset = plan.views / 10000;
          const quantityLabel = (quantity * 10000).toLocaleString();

          let quantityValue = quantity - quantityOffset;
          if (quantityValue < 0) {
            quantityValue = "";
          }

          // select the current plan
          const optionSelected =
            current_plan.stripe_plan == plan.stripe_plan &&
            plan.views / 10000 + (views_plan_quantity - quantityOffset) ==
              quantityValue;

          const optionTag = `<option value="${quantityValue}" ${
            optionSelected ? "selected" : ""
          }>${quantityLabel}</option>`;

          $(usageSelect).append(optionTag);
        });

      const contactOptionTag = '<option value="contact">600,000+</option>';
      $(usageSelect).append(contactOptionTag);

      $(usageSelect).on("change", function () {
        const selectedValue = $(usageSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? parseInt(selectedValue)
            : 0;

        // visualize price
        let price = plan.price;

        const annual_commit_discount = on_annual_paid_monthly == true;

        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }

        price = price + quantity * viewsPlan.price;

        const downgrade_inaccessible_on_contract =
          (annual_commit_discount &&
            price < current_plan.price + views_plan_quantity * 20) ||
          (["2023_build", "2023_launch", "2023_pro"].includes(plan_type) &&
            ["2023_scale", "2023_autopilot", "2023_enterprise"].includes(
              current_plan.plan_type
            ) &&
            !trial);

        $(priceLabel).html(price.toLocaleString());

        // build button
        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;

        if (
          ((free_plan && !trial) || (trial && !free_plan)) &&
          on_annual_paid_monthly !== true
        ) {
          buttonLink += "&trial=true";
        }

        if (quantity >= 0) {
          buttonLink += `&views_plan_quantity=${quantity}`;
        }

        if (on_annual_paid_monthly == true) {
          buttonLink += "&annual_paid_monthly=true";
        }

        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";

        const buttonText =
          free_plan && !trial
            ? "Start 14 day free trial"
            : plan_type == subscription.stripe_plan &&
              quantity == views_plan_quantity &&
              !downgrade_inaccessible_on_contract
            ? "Change plan term"
            : downgrade_inaccessible_on_contract
            ? "Account ineligible"
            : "Switch to this plan";

        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan && plan_type == "2023_build") ||
          (current_plan.stripe_plan == "2023_build" &&
            plan_type == "2023_launch") ||
          (current_plan.stripe_plan == "2023_launch" &&
            plan_type == "2023_pro") ||
          (current_plan.stripe_plan == "2023_pro" &&
            plan_type == "2023_scale") ||
          (current_plan.stripe_plan == "2023_scale" &&
            plan_type == "2023_autopilot")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
            ? "rgb(126, 147, 165)"
            : "";
        $(buttonTag).css("background", backgroundColor);

        // disable button if on annual contract and plan would be downgrade
        if (downgrade_inaccessible_on_contract) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        // show contact us button if interested in high traffic
        if (selectedValue == "contact") {
          buttonTag.innerHTML = "Contact Sales";
          buttonLinkTag.href = "#";

          $(buttonLinkTag)
            .off("click")
            .on("click", function () {
              const planTypePretty = plan_type.replace("2023_", "");
              const intercomMessage = `I'm interested in a high-traffic pricing for the ${planTypePretty} plan`;
              Intercom("showNewMessage", intercomMessage);
            });
        }

        $(buttonLinkTag).append(buttonTag);
        $(planOuterDiv).html(buttonLinkTag);

        if (
          plan.annual_plan &&
          !on_annual_paid_monthly &&
          !downgrade_inaccessible_on_contract
        ) {
          let annualLink = `${root_url}subscriptions/new?stripe_plan=${plan.annual_plan}&account_id=${subscription.account_id}`;

          if (quantity >= 0) {
            annualLink += `&views_plan_quantity=${quantity}`;
          }

          if (current_plan.stripe_plan == plan.annual_plan) {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important; color: #2bc3a6 !important;">
                You're saving $${
                  plan.price * 12 - plan.price * 10
                }/y by paying yearly 🙌
              </p>`
            );
          } else {
            $(planOuterDiv).append(
              `<p class="light center smooth" style="margin-bottom: 8px; font-size: 13px !important; margin-top: 15px !important;">
                <a style="color: #2bc3a6 !important;" href="${annualLink}" target="_blank">
                  Save $${plan.price * 12 - plan.price * 10}/y + ${
                plan_type == "2023_build"
                  ? "t-shirt"
                  : plan_type == "2023_launch"
                  ? "hoodie"
                  : plan_type == "2023_pro"
                  ? "swag box"
                  : "swag box"
              } with annual →
                </a>
              </p>`
            );
          }
        }
      });

      $(usageSelect).trigger("change");
    });
  });

  // 2022 pricing plans

  $(["2022_pro", "2022_team", "2022_business"]).each(function (i, plan_type) {
    let planTypeSelector = '.pricing-box-outer[data-plan="' + plan_type + '"]';

    $(planTypeSelector).each(function (i, plan_div) {
      const usageOuterDiv = $(plan_div).find(".plan-usage-select-outer");
      const usageOuterDivContent =
        'For <select class="field-control text-field plan-usage-select"></select> monthly visitors';
      const planOuterDiv = $(plan_div).find(".plan-button");
      const priceLabel = $(plan_div).find(".plan-price");
      const buttonWrapper = $(plan_div).find(".plan-button");

      // build visitors volume dropdown
      $(usageOuterDiv).html(usageOuterDivContent);
      const usageSelect = $(usageOuterDiv).find("select");

      [...Array(40).keys()]
        .filter(
          (quantity) =>
            (plan_type !== "2022_business" && quantity > 0) ||
            (plan_type == "2022_business" && quantity > 9)
        )
        .forEach((quantity) => {
          const quantityOffset = plan_type == "2022_business" ? 10 : 1;
          const quantityLabel = (quantity * 10000).toLocaleString();

          let quantityValue = quantity - quantityOffset;
          if (quantityValue < 0) {
            quantityValue = "";
          }

          // select the current plan
          const optionSelected =
            (plan_type !== "2022_business" &&
              visitors_plan_quantity == quantityValue) ||
            (plan_type == "2022_business" &&
              current_plan.stripe_plan !== "2022_business" &&
              visitors_plan_quantity - 9 == quantityValue);

          const optionTag = `<option value="${quantityValue}" ${
            optionSelected ? "selected" : ""
          }>${quantityLabel}</option>`;

          $(usageSelect).append(optionTag);
        });

      const contactOptionTag = '<option value="contact">400,000+</option>';
      $(usageSelect).append(contactOptionTag);

      $(usageSelect).on("change", function () {
        const plan = plans[plan_type];
        const selectedValue = $(usageSelect).val();
        const quantity =
          selectedValue && selectedValue !== "contact"
            ? parseInt(selectedValue)
            : 0;

        // visualize price
        let price = plan.price;

        const annual_commit_discount =
          on_annual_paid_monthly == true && plan_type !== "2022_business";

        if (annual_commit_discount == true) {
          price = Math.ceil(price - price * 0.0833);
        }

        price = price + quantity * 10;

        if (selectedValue == "contact") {
          if (plan_type !== "2022_business") {
            price = price + 40 * 10 + "+";
          } else {
            price = price + 30 * 10 + "+";
          }
        }

        const downgrade_inaccessible_on_contract =
          annual_commit_discount &&
          price < current_plan.price + visitors_plan_quantity * 10;

        $(priceLabel).html(price);

        // build button
        let buttonLinkTag = document.createElement("a");
        let buttonLink = `${root_url}subscriptions/new?stripe_plan=${plan_type}&account_id=${subscription.account_id}`;

        if (
          ((free_plan && !trial) || (trial && !free_plan)) &&
          on_annual_paid_monthly !== true &&
          plan_type !== "2022_business"
        ) {
          buttonLink += "&trial=true";
        }

        if (quantity >= 0) {
          buttonLink += `&visitors_plan_quantity=${quantity}`;
        }

        if (on_annual_paid_monthly == true && plan_type !== "2022_business") {
          buttonLink += "&annual_paid_monthly=true";
        }

        buttonLinkTag.href = buttonLink;

        let buttonTag = document.createElement("button");
        buttonTag.className = "btn btn-block pricing-button";

        const buttonText =
          free_plan && !trial
            ? "Start 14 day free trial"
            : plan_type == subscription.stripe_plan &&
              quantity == visitors_plan_quantity &&
              !downgrade_inaccessible_on_contract
            ? "Change plan term"
            : downgrade_inaccessible_on_contract
            ? "Account ineligible"
            : "Switch to this plan";

        buttonTag.innerHTML = buttonText;

        const backgroundColor =
          (free_plan && plan_type == "2022_pro") ||
          (current_plan.stripe_plan == "2022_pro" &&
            plan_type == "2022_team") ||
          (current_plan.stripe_plan == "2022_team" &&
            plan_type == "2022_business")
            ? "#003fff"
            : downgrade_inaccessible_on_contract
            ? "rgb(126, 147, 165)"
            : "";
        $(buttonTag).css("background", backgroundColor);

        // disable button if on annual contract and plan would be downgrade
        if (downgrade_inaccessible_on_contract) {
          buttonLinkTag.href = "#";
          $(buttonTag).addClass("disabled");
        }

        // show contact us button if interested in high traffic
        if (selectedValue == "contact") {
          buttonTag.innerHTML = "Contact Sales";
          buttonLinkTag.href = "#";

          $(buttonLinkTag)
            .off("click")
            .on("click", function () {
              const planTypePretty = plan_type.replace("2022_", "");
              const intercomMessage = `I'm interested in a high-traffic pricing for the ${planTypePretty} plan`;
              Intercom("showNewMessage", intercomMessage);
            });
        }

        $(buttonLinkTag).append(buttonTag);
        $(planOuterDiv).html(buttonLinkTag);
      });

      $(usageSelect).trigger("change");
    });
  });

  // 2021 pricing plans
  $.each(["month", "year"], function (i, interval) {
    $.each(
      ["2021_pro", "2021_business", "marketer", "pro", "business"],
      function (i, plan_type) {
        $(
          '.pricing-box-outer[data-plan="' +
            plan_type +
            '"][data-plan-interval="' +
            interval +
            '"]'
        ).each(function (i, plan_div) {
          var usage_outer = $(plan_div).find(".plan-usage-select-outer");
          $(usage_outer).html(
            'For <select class="field-control text-field plan-usage-select"></select> monthly visitors'
          );

          var scalable_plans = $.map(plans, function (i, plan_id) {
            if (
              plan_id.indexOf(plan_type) > -1 &&
              (["pro", "business"].indexOf(plan_type) == -1 ||
                plan_id.indexOf("2021") == -1) &&
              ((interval == "month" && plan_id.indexOf("annual") == -1) ||
                (interval == "year" && plan_id.indexOf("annual") > -1))
            )
              return plan_id;
          });

          $.each(scalable_plans, function (id, plan_id) {
            var plan = plans[plan_id];
            if (plan.visitors && plan.next_plan && plan.hidden !== true) {
              $(usage_outer)
                .find("select")
                .append(
                  '<option value="' +
                    plan_id +
                    '">' +
                    plan.visitors.toLocaleString() +
                    "</option>"
                );
            }
          });

          if (
            ["2021_pro", "2021_business", "business"].indexOf(plan_type) > -1
          ) {
            $(usage_outer)
              .find("select")
              .append('<option value="contact">2,000,000+</option>');
          }

          $(usage_outer)
            .find("select")
            .unbind("change")
            .on("change", function () {
              var plan_id = $(this).val();
              var plan = plans[plan_id];

              if (plan) {
                if (interval == "month") {
                  var price = plan.price;

                  if (on_annual_paid_monthly == true) {
                    price = Math.ceil(price - price * 0.0833);
                  }
                } else {
                  var price = Math.ceil(plan.price / 12);
                  $(plan_div)
                    .find(".annual-savings")
                    .html(
                      "<strike>$" +
                        (plan.price * 1.2).toLocaleString() +
                        "</strike> $" +
                        plan.price.toLocaleString() +
                        " annually (Save $" +
                        (plan.price * 1.2 - plan.price).toLocaleString() +
                        ")"
                    );
                }
                $(plan_div).find(".plan-price").html(price);

                var annual_upgrade =
                  current_usage_tier &&
                  interval == "year" &&
                  plans[subscription.stripe_plan].price * 10 == plan.price;

                var downgrade_inaccessible_on_contract =
                  on_annual_paid_monthly == true &&
                  ((interval == "month" && price < current_plan.price) ||
                    (interval !== "month" && price < current_plan.price));

                $(plan_div)
                  .find(".plan-button")
                  .html(
                    '<a href="' +
                      root_url +
                      "subscriptions/new?stripe_plan=" +
                      plan_id +
                      "&account_id=" +
                      subscription.account_id +
                      (((free_plan && !trial) || (trial && !free_plan)) &&
                      interval == "month" &&
                      on_annual_paid_monthly !== true
                        ? "&trial=true"
                        : "") +
                      (on_annual_paid_monthly == true && interval == "month"
                        ? "&annual_paid_monthly=true"
                        : "") +
                      '">' +
                      '<button class="btn btn-block pricing-button" style="background: ' +
                      (free_plan ||
                      (annual_upgrade &&
                        downgrade_inaccessible_on_contract !== true)
                        ? "#00b591 !important"
                        : plan_id == subscription.stripe_plan ||
                          downgrade_inaccessible_on_contract
                        ? "rgb(126, 147, 165)"
                        : "") +
                      '">' +
                      (free_plan && !trial && interval == "month"
                        ? "Start 14 day free trial"
                        : plan_id == subscription.stripe_plan
                        ? "Your current plan"
                        : downgrade_inaccessible_on_contract
                        ? "Account ineligible"
                        : (trial && !free_plan) ||
                          subscription.stripe_plan.indexOf("k") == -1
                        ? "Switch to this plan"
                        : current_usage_tier &&
                          current_usage_tier <=
                            parseInt(plan_id.split("_").pop().replace("k", ""))
                        ? "Upgrade to this plan"
                        : annual_upgrade
                        ? "Switch to annual"
                        : "Switch to this plan") +
                      "</button>" +
                      "</a>"
                  );

                if (
                  plan_id == subscription.stripe_plan ||
                  downgrade_inaccessible_on_contract
                ) {
                  $(plan_div).find(".plan-button a").removeAttr("href");
                  $(plan_div).find(".plan-button button").addClass("disabled");
                }
              }

              if (
                plan_id == "contact" ||
                (((plan.interval == "month" && plan.price > 300) ||
                  (plan.interval == "year" && plan.price > 3000)) &&
                  (subscription.stripe_plan == "free" ||
                    (current_plan.plan_type == "2021_pro" &&
                      current_plan.interval == "month" &&
                      current_plan.price < 300) ||
                    (current_plan.plan_type == "2021_pro" &&
                      current_plan.interval == "year" &&
                      current_plan.price < 3000) ||
                    current_plan.plan_type == "2021_business"))
              ) {
                var prepopulatedMessage;
                var priceToShow;

                if (plan && plan.price > 300) {
                  prepopulatedMessage = "I'm interested in a high-traffic plan";
                  priceToShow = "300+";
                }

                if (plan_id == "contact") {
                  prepopulatedMessage =
                    "I'm interested in a customized pricing plan";
                  priceToShow = "2,000+";
                  $(plan_div).find(".plan-name").html("Custom");
                }

                $(plan_div).find(".plan-price").html(priceToShow);

                $(plan_div)
                  .find(".plan-button")
                  .html(
                    '<button class="btn btn-block pricing-button" style="background: #00b591 !important">Contact Us</button>'
                  );

                $(plan_div)
                  .find(".pricing-button")
                  .on("click", function () {
                    Intercom("showNewMessage", prepopulatedMessage);
                  });

                if (interval == "year") {
                  $(plan_div)
                    .find(".annual-savings")
                    .html("2 months free with annual");
                }
              } else {
                var original = $(plan_div)
                  .find(".plan-name")
                  .attr("data-original-name");
                $(plan_div).find(".plan-name").html(original);
              }
            });

          if (current_usage_tier) {
            var plan_option = $(usage_outer).find(
              'select option[value="' + subscription.stripe_plan + '"]'
            );

            if ($(plan_option)[0]) {
              $(plan_option).attr("selected", "true");
            }

            if (
              interval == "year" &&
              subscription.stripe_plan.indexOf("annual") == -1
            ) {
              var annual_plan_option = $(usage_outer).find(
                'select option[value="' + subscription.stripe_plan + '_annual"]'
              );

              if ($(annual_plan_option)[0]) {
                $(annual_plan_option).attr("selected", "true");
              }
            }
          }

          $(usage_outer).find("select").trigger("change");
        });
      }
    );
  });
};

export default pricing_table;
